class FcProductSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.fc-slider-wrapper');
    this.prevBtn = this.querySelector('.fc-slider-button.prev');
    this.nextBtn = this.querySelector('.fc-slider-button.next');
    this.slideItems = Array.from(this.querySelectorAll('.fc-slide-item'));
    this.controls = this.querySelector('.fc-slider-controls');
    this.currentIndex = 0;

    if (!this.slider || !this.prevBtn || !this.nextBtn) return;

    this._onResize = () => setTimeout(() => this._update(), 100);
    this.prevBtn.addEventListener('click', () => this._navigate(-1));
    this.nextBtn.addEventListener('click', () => this._navigate(1));
    window.addEventListener('resize', this._onResize);
    this._update();

    this._initSwipeHide();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  _slideWidth() {
    const containerWidth = this.slider.parentElement.offsetWidth;
    if (window.innerWidth >= 750) return containerWidth / 3;
    const padding = 30, max = 400, min = 280;
    const ideal = Math.max(
      min + padding,
      Math.min(max + padding, containerWidth / Math.ceil(containerWidth / (max + padding)))
    );
    return containerWidth / Math.floor(containerWidth / ideal);
  }

  _visibleCount(slideWidth) {
    if (window.innerWidth >= 750) return 3;
    return Math.floor(this.slider.parentElement.offsetWidth / slideWidth);
  }

  _navigate(dir) {
    const sw = this._slideWidth();
    const maxIndex = Math.max(0, this.slideItems.length - this._visibleCount(sw));
    this.currentIndex = Math.max(0, Math.min(maxIndex, this.currentIndex + dir));
    this._update();
  }

  _update() {
    const sw = this._slideWidth();
    const containerWidth = this.slider.parentElement.offsetWidth;
    const visible = this._visibleCount(sw);
    const maxIndex = Math.max(0, this.slideItems.length - visible);

    this.slideItems.forEach(item => {
      item.style.flexBasis = sw + 'px';
      item.style.width = sw + 'px';
    });

    if (this.currentIndex > maxIndex) this.currentIndex = maxIndex;
    this.slider.style.left = (-this.currentIndex * sw) + 'px';

    if (this.controls) {
      this.controls.style.display =
        this.slideItems.length * sw > containerWidth ? 'flex' : 'none';
    }

    this.prevBtn.disabled = this.currentIndex <= 0;
    this.prevBtn.setAttribute('aria-disabled', String(this.currentIndex <= 0));
    this.nextBtn.disabled = this.currentIndex >= maxIndex;
    this.nextBtn.setAttribute('aria-disabled', String(this.currentIndex >= maxIndex));
  }

  _initSwipeHide() {
    if (!document.getElementById('swipe-hide-css')) {
      const style = document.createElement('style');
      style.id = 'swipe-hide-css';
      style.textContent = `.product-grid.slider.swipe-used li:first-child::after,
        .product-grid.slider.swipe-used li:first-child:after {
          display: none; opacity: 0; content: none; visibility: hidden;
        }`;
      document.head.appendChild(style);
    }

    const slider = this.parentElement?.querySelector('.product-grid.slider');
    if (!slider) return;

    const key = 'swipe-used-' + (slider.id || (slider.id = 'slider-' + Math.random().toString(36).slice(2)));

    if (sessionStorage.getItem(key)) {
      slider.classList.add('swipe-used');
      return;
    }

    let startX, startY, triggered = false;

    slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      if (triggered) return;
      const dx = Math.abs(e.touches[0].clientX - startX);
      const dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > 25 && dx > dy * 1.2) {
        triggered = true;
        slider.classList.add('swipe-used');
        sessionStorage.setItem(key, 'true');
      }
    }, { passive: true });
  }
}

customElements.define('fc-product-slider', FcProductSlider);
